export default function TextImage({ title, description, image, alt, overlay, buttonText, handleClick, orientation = 'right' }) {
    const imageOnLeft = orientation === 'left';

    return (
        <section className={`flex flex-col ${imageOnLeft ? 'md:flex-row' : 'md:flex-row-reverse'}` }>
            <div className={`flex flex-col justify-center px-6 py-5 md:px-14 gap-10 md:w-1/2 text-center ${imageOnLeft ? 'md:text-right' : 'md:text-left'}`}>
                <h2 className={`text-3xl xl:text-5xl text-mcare-green font-semibold md:drop-shadow-lg text-balance panoragraf-light 
                    ${imageOnLeft ? 'md:text-left' : 'md:text-right'}`} data-aos="fade">
                    {title}
                </h2>

                {description}

                {buttonText && (
                    <button
                        onClick={handleClick}
                        className={`progress-button-mcare px-8 py-2 uppercase font-semibold tracking-wider text-center transition duration-300 ease-in-out w-full lg:w-fit ${imageOnLeft ? 'md:self-start' : 'md:self-end'}`}
                    >
                        {buttonText}
                    </button>
                )}
            </div>
            <div className="w-full md:w-1/2 h-full relative">
                <img src={image} alt={alt} className="w-full h-full object-cover shadow-lg" />
                {overlay && <div className="bg-black/50 absolute inset-0"/>}
            </div>
        </section>
    );
}
